import { render, staticRenderFns } from "./PlantillasRecursosHumanosView.vue?vue&type=template&id=31ca782c&"
import script from "./PlantillasRecursosHumanosView.vue?vue&type=script&lang=js&"
export * from "./PlantillasRecursosHumanosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports